import { alpha, Theme } from "@mui/material/styles";
import { ResolvedPaletteColorTokens } from "./walletTheme.types";

export const extendPaletteColor = (color: ResolvedPaletteColorTokens) => ({
  ...color,
  lighter: alpha(color.light, 0.24),
  darker: color.dark,
});

export type StatusTone =
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "neutral"
  | "pending";

export const getStatusChipToneStyles = (
  theme: Theme,
  tone: StatusTone
): { bg: string; fg: string; dot: string } => {
  const { palette } = theme;

  switch (tone) {
    case "success":
      return {
        bg: alpha(palette.success.main, 0.12),
        fg: palette.success.dark,
        dot: palette.success.main,
      };
    case "danger":
      return {
        bg: alpha(palette.error.main, 0.12),
        fg: palette.error.dark,
        dot: palette.error.main,
      };
    case "warning":
      return {
        bg: alpha(palette.warning.main, 0.16),
        fg: palette.warning.dark,
        dot: palette.warning.main,
      };
    case "info":
      return {
        bg: alpha(palette.info.main, 0.12),
        fg: palette.info.dark,
        dot: palette.info.main,
      };
    case "pending":
      return {
        bg: alpha(palette.secondary.main, 0.12),
        fg: palette.secondary.dark,
        dot: palette.secondary.main,
      };
    case "neutral":
    default:
      return {
        bg: palette.grey[200],
        fg: palette.grey[700],
        dot: palette.grey[500],
      };
  }
};
